import SvgColor from '../../../components/svg-color';

// Function to generate icons
const icon = (name) => (
  <SvgColor src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1, color: '#fff' }} />
);

const storedPermissions = JSON.parse(localStorage.getItem('client')) || [];
const permissionForAdministrator = storedPermissions.administrator;
const instantSignup = storedPermissions.instantSignup;

const navConfig = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    icon: icon('ic_analytics'),
    name: 'View-Dashboard',
  },
];

// Conditionally add items based on permissionForAdministrator
if (permissionForAdministrator) {
 
  if(permissionForAdministrator && !instantSignup){

    navConfig.push(
      {
        title: 'Account',
        path: '/account',
        icon: icon('account'),
        name: 'Account',
      },
        {
      title: 'Subscriptions',
      path: '/subscriptions',
      icon: icon('plans'),
      name: 'Subscriptions',
    },
      {
        title: 'Billing',
        path: '/billing',
        icon: icon('billings'),
        name: 'Billing',
      },
      {
        title: 'Teachers',
        path: '/teachers',
        icon: icon('ic_user'),
        name: 'Teacher',
      },
      {
        title: 'Contact Us',
        path: '/contact-us',
        icon: icon('contact'),
        name: 'Contact Us',
      },
      // {
      //   title: 'Policies',
      //   path: '/policies',
      //   icon: icon('policy_icon'),
      //   name: 'Policies',
      // }
    )
  }
  if(instantSignup && permissionForAdministrator){
    navConfig.push(
      {
        title: 'Profile',
        path: '/profile',
        icon: icon('ic_user'),
        name: 'Profile',
      },
      {
        title: 'Upload Task',
        icon: icon('upload'),
        name: 'UploadTask',
        submenu:true,
        submenu:[
          { title: 'Upload & Extract',
            path: '/upload-task',
             icon: icon('upload-picture'),
             name: 'UploadTask'
          },
          {
            title: 'Text Input',
            path: '/task-upload-by-value',
            icon: icon('upload-value'),
            name: 'UploadTask',
          }
        ]
      },
        {
      title: 'Subscriptions',
      path: '/subscriptions',
      icon: icon('plans'),
      name: 'Subscriptions',
    },
      {
        title: 'Billing',
        path: '/billing',
        icon: icon('billings'),
        name: 'Billing',
      },
      {
        title: 'SES',
        path: '/ses',
        icon: icon('ses_icon'),
        name: 'Ses',
      },
      {
        title: 'Settings',
        path: '/credentials',
        icon: icon('settings-white'),
        name: 'Settings',
      },
      {
        title: 'Contact Us',
        path: '/contact-us',
        icon: icon('contact'),
        name: 'Contact Us',
      },
      // {
      //   title: 'Policies',
      //   path: '/policies',
      //   icon: icon('policy_icon'),
      //   name: 'Policies',
      // }
    );
  }
  navConfig.push(
    // {
    //   title: 'Subscriptions',
    //   path: '/subscriptions',
    //   icon: icon('plans'),
    //   name: 'Subscriptions',
    // },
    // {
    //   title: 'Billing',
    //   path: '/billing',
    //   icon: icon('billings'),
    //   name: 'Billing',
    // },
    // {
    //   title: 'Support',
    //   path: '/support',
    //   icon: icon('support'),
    //   name: 'Support',
    // }, 
    {
      title: 'FAQs',
      path: '/faq',
      icon: icon('billings'),
      name: 'FAQs',
    },
     {
        title: 'Policies',
        path: '/policies',
        icon: icon('policy_icon'),
        name: 'Policies',
      }
  );
} else {
  navConfig.push(
    {
      title: 'Profile',
      path: '/profile',
      icon: icon('ic_user'),
      name: 'Account',
    },
    // {
    //   title: 'Upload Task',
    //   path: '/upload-task',
    //   icon: icon('upload'),
    //   name: 'UploadTask',
    // },
    {
      title: 'Upload Task',
      // path: '/upload-task',
      icon: icon('upload'),
      name: 'UploadTask',
      submenu:true,
      submenu:[
        { title: 'Upload & Extract',
          path: '/upload-task',
           icon: icon('upload-picture'),
           name: 'UploadTask'
        },
        {
          title: 'Text Input',
          path: '/task-upload-by-value',
          icon: icon('upload-value'),
          name: 'UploadTask',
        }
      ]
    },
    {
      title: 'SES',
      path: '/ses',
      icon: icon('ses_icon'),
      name: 'Ses',
    },
    {
      title: 'Settings',
      path: '/credentials',
      icon: icon('settings-white'),
      name: 'Settings',
    },
    {
      title: 'Contact Us',
      path: '/contact-us',
      icon: icon('contact'),
      name: 'Contact Us',
    },
    {
      title: 'Policies',
      path: '/policies',
      icon: icon('policy_icon'),
      name: 'Policies',
    }
  );
}

export default navConfig;
